import { render, staticRenderFns } from "./StatusMessagesChart.vue?vue&type=template&id=56b5989d&scoped=true"
import script from "./StatusMessagesChart.vue?vue&type=script&lang=js"
export * from "./StatusMessagesChart.vue?vue&type=script&lang=js"
import style0 from "./StatusMessagesChart.vue?vue&type=style&index=0&id=56b5989d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b5989d",
  null
  
)

export default component.exports